import { HousesViews } from 'gcs-common/constants/views';
import { resetAdministrationUsers } from 'gcs-common/slices/administration/administrationUsers/administrationUsersSlice';
import {
  getActiveHouse,
  getActiveHouseId,
  getAllHousesPlainList,
  getHouseLoading,
  getHouseLoadingError,
  getHousesLoading,
} from 'gcs-common/slices/administration/houses/housesSelectors';
import { globalHouseIdSelected } from 'gcs-common/slices/administration/houses/housesSlice';
import { fetchHouse, fetchHouses } from 'gcs-common/slices/administration/houses/housesThunks';
import { getHasPermission } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getJoinedHousesIds } from 'gcs-common/slices/houses/housesSelectors';
import { getIsOnline } from 'gcs-common/slices/offline/offlineSelectors';
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import styles from './styles.module.scss';

const HouseSelectBar = ({ resetSearchFilter }) => {
  const isGlobalAdmin = useSelector(getHasPermission('global_admin'));

  const activeHouse = useSelector(getActiveHouse);
  const activeHouseId = useSelector(getActiveHouseId);

  const housesLoading = useSelector(getHousesLoading);
  const isOnline = useSelector(getIsOnline);
  const houseLoading = useSelector(getHouseLoading);
  const houseError = useSelector(getHouseLoadingError);
  const houses = useSelector(getAllHousesPlainList);
  const userHouses = useSelector(getJoinedHousesIds);
  const userHousesCount = userHouses?.length;

  const dispatch = useDispatch();

  useEffect(() => {
    if (isOnline && !activeHouse && !(houseLoading || housesLoading || houseError)) {
      dispatch(fetchHouse({ houseId: activeHouseId }));
    }
  }, [activeHouse, activeHouseId, dispatch, isOnline, houseLoading, houses, housesLoading, houseError]);

  const loadHouses = useCallback(
    (searchQuery = null) => {
      dispatch(
        fetchHouses({
          searchQuery,
          view: HousesViews.PLAIN,
        }),
      );
    },
    [dispatch],
  );

  useEffect(() => {
    loadHouses();
  }, [loadHouses]);

  const onChange = useCallback(
    async (value) => {
      const { id: selectedHouseId } = value;
      resetSearchFilter();
      dispatch(resetAdministrationUsers());
      await dispatch(globalHouseIdSelected({ houseId: selectedHouseId }));
    },
    [dispatch, resetSearchFilter],
  );

  if (!isGlobalAdmin && userHousesCount === 1) {
    return (
      <div className={styles.settingsHeader}>
        {/* biome-ignore lint/complexity/useOptionalChain: <explanation> */}
        {activeHouse && activeHouse.friendlyName}
      </div>
    );
  }

  return (
    <div className={styles.select}>
      <Select
        isLoading={houseLoading || housesLoading}
        className={styles.selectBar}
        placeholder="Haus auswählen"
        options={houses}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.friendlyName}
        value={activeHouse}
        onChange={onChange}
        onInputChange={loadHouses}
      />
    </div>
  );
};

HouseSelectBar.propTypes = {
  resetSearchFilter: PropTypes.func.isRequired,
};

export default HouseSelectBar;
